(function ($) {
    $(function () {
        $(".social-media-disconnect").hover(
            function () {
                $(this).find("span").text("Disconnect");
            },
            function () {
                $(this).find("span").text("Connected");
            }
        );
    });
})(jQuery);
